// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const serializeQuery = (query: any) => {
  return Object.keys(query)
    .map((key) => `${encodeURIComponent(key)}=${encodeURIComponent(query[key])}`)
    .join('&');
};
